<template>
   <InputText
      size="small"
      type="text"
      fluid
      class="w-full"
      v-model="model"
      :disabled="disabled"
      :mask="mask"
      :placeholder="placeholder"
      inputmode="tel"
      autocomplete="off"
   />
</template>

<script setup>
   import allCountries from '@/composables/countries.js';
   import { onMounted, ref } from 'vue';
   import { getCountryCallingCode, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js/max';
   import { isEmpty } from 'lodash';
   import { InputMask, InputText, Select } from 'primevue';
   import { usePhoneInputMask } from '@/composables/usePhoneInputMask.js';

   defineProps({
      disabled: {
         type: Boolean,
         default: false,
      },
   });

   const {getMask} = usePhoneInputMask();

   const mask = ref('+999 99999999');
   const placeholder = ref('+357 xxxxxxxx');

   const phoneCode = ref('CY');
   const model = defineModel({
      type: String,
      required: false,
   });


   const countryCodeChanged = (event) => {
      try {
         const callingCode = getCountryCallingCode(event.value);
         const phoneMask = getMask(callingCode);
         mask.value = phoneMask.replace(/#/g, '9');
         placeholder.value = phoneMask.replace(/#/g, 'x');
      } catch (e) {

      }
   };
</script>

<style scoped></style>
